import { useEffect, useState } from "react";

/**
 * Returns `true` when scrollY is greater than threshold
 * @param threshold - Vertical scroll position in pixels to trigger the state
 */
export function useScrolled(threshold: number = 50): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > threshold);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // check immediately on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return scrolled;
}
